<template>
  <div id="app">
    <router-view></router-view>
    <!-- <views /> -->
  </div>
</template>

<script>
// import views from './views/index.vue'
export default {
  name: 'App',
  // components: {
  //   views,
  // },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
